import { Link, useNavigate } from "react-router-dom";
import "./home.css"; 
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import CloseIcon from "@mui/icons-material/Close";
// Icon cho thanh sidebar
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import TelegramIcon from "@mui/icons-material/Telegram";
import FacebookIcon from "@mui/icons-material/Facebook";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import Header from "../components/Header";

// Cấu hình Axios
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.warn("Token hết hạn, dọn dẹp...");
            localStorage.removeItem("user");
            localStorage.removeItem("profile");
        }
        return Promise.reject(error);
    }
);

function Home() {
    SwiperCore.use([Autoplay, Navigation, Pagination]);
    const navigate = useNavigate();

    // ================= STATES BẢN ĐẦU CỦA HOME =================
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")) || []);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [wcMatches, setWcMatches] = useState([]);

    // ================= STATES CHO KHUYẾN MÃI (TỪ PROMOTION) =================
    const [notifyItem, setNotifyItem] = useState(null);
    const [isShow, setShow] = useState(false);

    // ================= STATES MỚI CHO LOGIC GAME =================
    const [isLoading, setLoading] = useState(false);
    const [playGame, setPlayGame] = useState(null); 
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);

    // Swiper Configs
    const swiperParams = { autoplay: { delay: 3500, disableOnInteraction: false } };
    const swiperBanner = {
        autoplay: { delay: 3000, disableOnInteraction: false },
        slidesPerView: 1.2, 
        breakpoints: {
            640: { slidesPerView: 2.2, spaceBetween: 15 },
            768: { slidesPerView: 3, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
        },
        spaceBetween: 10,
        grabCursor: true
    };
    
    const swiperWC = {
        autoplay: { delay: 4000, disableOnInteraction: false }, 
        slidesPerView: 1.2,
        breakpoints: {
            640: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 3, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 20 },
        },
        spaceBetween: 20,
        grabCursor: true,
        navigation: true,
        pagination: { clickable: true },
    };

    // Helpers
    function formatNumber(number) { return number < 10 ? `0${number}` : `${number}`; }
    function formatTime(timeString) {
        if (!timeString) return "00:00";
        const dateTime = new Date(timeString);
        return `${formatNumber(dateTime.getHours())}:${formatNumber(dateTime.getMinutes())}`;
    }
    function formatDay(timeString) {
        if (!timeString) return "01 Jul";
        const dateTime = new Date(timeString);
        return `${formatNumber(dateTime.getDate())} Tháng ${dateTime.getMonth() + 1}`;
    }
    function handleImageError(e, num) {
        e.target.onerror = null;
        e.target.src = num === 1 
            ? "https://static.uni247.xyz/images-v3/srcompetitor%20away.svg" 
            : "https://static.uni247.xyz/images-v3/srcompetitor%20home.svg";
    }

    // ================= LOGIC GAME TỪ CASINO.JS =================
    const autoRecoverMoney = (productType) => {
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType, type: 2, money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                localStorage.removeItem("playing_product");
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => console.log("Lỗi tự động thu hồi tiền phiên cũ:", err));
    };

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function launchGame(params) {
        if (!localStorage.getItem("profile") || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = { ...params, platform: isMobileDevice() === true ? "html5" : "html5-desktop" };
        setLoading(true);

        let nameSanh = "";
        switch (params.product_type) {
            case "112": nameSanh = "SEXY"; break;
            case "118": nameSanh = "WM"; break;
            case "4": nameSanh = "SA"; break;
            case "174": nameSanh = "SABA"; break;
            case "104": nameSanh = "CMD"; break;
            case "54": nameSanh = "SBO"; break;
            case "151": nameSanh = "UG"; break;
            case "1001": nameSanh = "LuckySports"; break; 
            case "142": nameSanh = "FB0001"; break; 
            default: nameSanh = "SẢNH GAME"; break;
        }
        setSanh(nameSanh);
        setProduct(params.product_type);

        axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status === 0) {
                    const gameUrl = res.data.data.game_url;
                    if (profile && profile.money > 0) {
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1, 
                            money: Math.floor(profile.money)
                        };
                        axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));
                                    localStorage.setItem("playing_product", params.product_type);
                                    window.history.pushState({ inGame: true }, "");
                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                localStorage.setItem("playing_product", params.product_type);
                                window.history.pushState({ inGame: true }, "");
                                setPlayGame(gameUrl);
                                setLoading(false);
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    const handleCloseGame = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: product, type: 2, money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`))
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                localStorage.removeItem("playing_product");
                setPlayGame(null); 
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null); 
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) handleCloseGame();
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [playGame, product]);

    // ================= DATA FETCHING =================
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
            const interruptedProduct = localStorage.getItem("playing_product");
            if (interruptedProduct) {
                autoRecoverMoney(interruptedProduct);
            }
        }).catch(() => {});

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (JSON.stringify(notify) !== JSON.stringify(res.data.data)) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        }).catch(() => {});

      const fetchWCNext7Days = async () => {
    try {
        const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/api-sport/wc`
        );

        const events = res.data.data.flatMap(item => item.events || []);

        setWcMatches(events);
    } catch (err) {
        console.log(err);
    }
};
        fetchWCNext7Days();
    }, [notify]); 

    // Lọc tìm item marquee (Fix lỗi thanh chạy thông báo)
    const marqueeItem = notify?.find(item => item.title === "marquee" && item.isShow === true);

    return (
        <div className="main-layout-bg">
            <Header profile={profile} />

            {/* Màn hình loading khi vào game */}
            {isLoading === true && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#00d2ff', fontWeight: 'bold' }}>
                    Đang xử lý...
                </div>
            )}
            
            {/* ================= BANNER CHÍNH ================= */}
    {notify && notify.length > 0 && (
                <div className="main-banner-wrap">
                    <Swiper {...swiperParams}>
                        {notify.map((item, index) => {
                            // CHỈ HIỂN THỊ CÁC THÔNG BÁO CÓ VỊ TRÍ LÀ 'home' (BANNER TRANG CHỦ)
                            if (item.isShow === true && item.displayLocation === "home") {
                                return (
                                    <SwiperSlide key={index}>
                                        <img 
                                            alt={item.title ? item.title.replace(/[{}]+/g, "") : "Banner"} 
                                            src={item.image} 
                                            style={{ width: "100%", maxHeight: "500px", objectFit: "cover", display: "block" }} 
                                        />
                                    </SwiperSlide>
                                )
                            }
                            return null;
                        })}
                    </Swiper>
                </div>
            )}

            {/* THÔNG BÁO MARQUEE (ĐÃ FIX LỖI) */}
            {marqueeItem && (
                <div className="marquee-bar">
                    <div className="marquee-container">
                        <div className="marquee-icon">
                            <VolumeUpIcon style={{ marginRight: "10px", color: "#00d2ff" }} />
                        </div>
                        <div className="marquee-content" style={{ display: 'flex', alignItems: 'center' }}>
                            <marquee scrollamount="5" style={{ width: '100%' }}>
                                <span dangerouslySetInnerHTML={{ __html: marqueeItem.content }} />
                            </marquee>
                        </div>
                    </div>
                </div>
            )}
            
            <div className="full-width-section">
                
                <div className="content-wrapper">
                    
                    {/* ================= SECTION: WORLD CUP ================= */}
                    <div className="wc-section">
                        <Swiper {...swiperWC} className="wc-swiper">
                            {wcMatches.length > 0 ? wcMatches.map((item, index) => {
                                const home = item.sport_event?.competitors?.[0];
                                const away = item.sport_event?.competitors?.[1];
                                return (
                                    <SwiperSlide key={index}>
                                        <div className="wc-card">
                                            <div className="wc-header">WORLDCUP 2026</div>
                                            <div className="wc-time">{formatDay(item.sport_event?.start_time)} | {formatTime(item.sport_event?.start_time)}</div>
                                            
                                            <div className="wc-teams">
                                                <div className="team">
                                                    <img src={home?.logo || "https://static.uni247.xyz/images-v3/srcompetitor%20home.svg"} alt="home" onError={(e) => handleImageError(e, 0)} />
                                                    <span>{home?.name || "ENGLAND"}</span>
                                                </div>
                                                <div className="vs">VS</div>
                                                <div className="team">
                                                    <img src={away?.logo || "https://static.uni247.xyz/images-v3/srcompetitor%20away.svg"} alt="away" onError={(e) => handleImageError(e, 1)} />
                                                    <span>{away?.name || "CONGO"}</span>
                                                </div>
                                            </div>
                                            
                                            <div className="wc-btn-wrap">
                                                <Link onClick={() => launchGame({ product_type: "174", game_code: "SB0001" })} className="btn-cyan btn-wc">Chơi ngay</Link>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            }) : (
                                <div style={{textAlign: "center", color: "#64748b", padding: "20px"}}>Đang tải dữ liệu giải đấu...</div>
                            )}
                        </Swiper>
                    </div>

                    {/* ================= TITLE: HOT NHẤT ================= */}
                    <div className="section-title-wrap">
                        <div className="tech-line left"></div>
                        <h2 className="section-title">Hot Nhất</h2>
                        <div className="tech-line right"></div>
                    </div>

                    {/* ================= GRID: THỂ THAO & CASINO ================= */}
                    <div className="hot-grid">
                        
                        {/* CỘT TRÁI: THỂ THAO */}
                        <div className="hot-col sports-col">
                            <div className="col-header">
                                <div className="title">
                                    <img src="https://i.ibb.co/C3b8DNW6/image.png" alt="icon" className="title-icon" /> 
                                    Cá cược thể thao
                                </div>
                            </div>
                            
                            <div className="sports-card-main">
                                <img className="sports-character" src="https://i.ibb.co/twg4rMV2/image.png" alt="sports character" />
                                
                                <div className="sports-info">
                                    <h2>Cá cược thể<br/>thao</h2>
                                    <p>THE WORLD'S FIRST COMPANY TO PROVIDE APPLE + ANDROID NATIVE MOBILE SPORTS, 300% SMOOTHER THAN THE WEB VERSION OF SPORTS.</p>
                                    
                                    <div className="provider-grid">
                                        <div className="p-item" onClick={() => launchGame({ product_type: "174", game_code: "SB0001" })}>
                                            <div className="p-icon" style={{ backgroundImage: "url('https://i.ibb.co/VcXKPt6k/image.png')" }}>
                                                <img src="https://images.191829838.com//TCG_PROD_IMAGES/VENDOR_ICON_SMALL/SB-ACTIVE.png" alt="saba"/>
                                            </div>
                                            <span>Saba Sports</span>
                                        </div>
                                        
                                        <div className="p-item" onClick={() => launchGame({ product_type: "104", game_code: "CMD001" })}>
                                            <div className="p-icon" style={{ backgroundImage: "url('https://i.ibb.co/VcXKPt6k/image.png')" }}>
                                                <img src="https://images.191829838.com//TCG_PROD_IMAGES/VENDOR_ICON_SMALL/CMD-ACTIVE.png" alt="cmd"/>
                                            </div>
                                            <span>CMD</span>
                                        </div>
                                        
                                        <div className="p-item" onClick={() => launchGame({ product_type: "54", game_code: "SBO001" })}>
                                            <div className="p-icon" style={{ backgroundImage: "url('https://i.ibb.co/VcXKPt6k/image.png')" }}>
                                                <img src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/SBO-COLOR2.png" alt="sbo"/>
                                            </div>
                                            <span>SBO</span>
                                        </div>
                                        
                                        <div className="p-item" onClick={() => launchGame({ product_type: "151", game_code: "UG2001" })}>
                                            <div className="p-icon" style={{ backgroundImage: "url('https://i.ibb.co/VcXKPt6k/image.png')" }}>
                                                <img src="https://images.191829838.com//TCG_PROD_IMAGES/VENDOR_ICON_SMALL/UG2-ACTIVE.png" alt="ug"/>
                                            </div>
                                            <span>United Gaming</span>
                                        </div>
                                        
                                      
                                        
                                        <div className="p-item" onClick={() => launchGame({ product_type: "142", game_code: "FB0001" })}>
                                            <div className="p-icon" style={{ backgroundImage: "url('https://i.ibb.co/VcXKPt6k/image.png')" }}>
                                                <img src="https://images.191829838.com//TCG_PROD_IMAGES/VENDOR_ICON_SMALL/123BET-ACTIVE.png" alt="bti"/>
                                            </div>
                                            <span>BTi</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* CỘT PHẢI: CASINO */}
                        <div className="hot-col casino-col">
                            <div className="col-header">
                                <div className="title">
                                    <img src="https://i.ibb.co/WvRcYPfw/image.png" alt="icon" className="title-icon" /> 
                                    Casino trực tuyến
                                </div>
                            </div>

                            <div className="casino-list">
                                <div onClick={() => launchGame({ product_type: "112", game_code: "SEX001" })} style={{ display: "block", borderRadius: "12px", position: "relative", overflow: "hidden", transition: "transform 0.3s", cursor: "pointer" }} className="promo-slide">
                                    <img src="https://i.ibb.co/XxyQQgTG/image.png" alt="Sexy Casino" style={{ width: "100%", display: "block", objectFit: "cover" }} />
                                    <div style={{ position: "absolute", top: 0, left: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "20px" }}>
                                        <h3 style={{ fontSize: "22px", fontWeight: "900", color: "#fff", margin: "0 0 10px 0", textShadow: "1px 1px 3px rgba(0,0,0,0.8)", textTransform: "uppercase" }}>SEXY CASINO</h3>
                                        <button className="btn-cyan btn-sm" style={{ width: "fit-content", padding: "6px 20px" }}>ĐẶT CƯỢC</button>
                                    </div>
                                </div>

                                <div onClick={() => launchGame({ product_type: "118", game_code: "WM0001" })} style={{ display: "block", borderRadius: "12px", position: "relative", overflow: "hidden", transition: "transform 0.3s", cursor: "pointer" }} className="promo-slide">
                                    <img src="https://i.ibb.co/MkZVQZYD/image.png" alt="ViA Casino" style={{ width: "100%", display: "block", objectFit: "cover" }} />
                                    <div style={{ position: "absolute", top: 0, left: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "20px" }}>
                                        <h3 style={{ fontSize: "22px", fontWeight: "900", color: "#fff", margin: "0 0 10px 0", textShadow: "1px 1px 3px rgba(0,0,0,0.8)", textTransform: "uppercase" }}>ViA CASINO</h3>
                                        <button className="btn-cyan btn-sm" style={{ width: "fit-content", padding: "6px 20px" }}>ĐẶT CƯỢC</button>
                                    </div>
                                </div>
                                
                                <div onClick={() => launchGame({ product_type: "4", game_code: "A00070" })} style={{ display: "block", borderRadius: "12px", position: "relative", overflow: "hidden", transition: "transform 0.3s", cursor: "pointer" }} className="promo-slide">
                                    <img src="https://i.ibb.co/1tV12JBX/image.png" alt="SA Casino" style={{ width: "100%", display: "block", objectFit: "cover" }} />
                                    <div style={{ position: "absolute", top: 0, left: 0, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "20px" }}>
                                        <h3 style={{ fontSize: "22px", fontWeight: "900", color: "#fff", margin: "0 0 10px 0", textShadow: "1px 1px 3px rgba(0,0,0,0.8)", textTransform: "uppercase" }}>SA CASINO</h3>
                                        <button className="btn-cyan btn-sm" style={{ width: "fit-content", padding: "6px 20px" }}>ĐẶT CƯỢC</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ================= SECTION KHUYẾN MÃI ================= */}
                   {/* ================= SECTION KHUYẾN MÃI ================= */}
<div style={{ marginTop: "50px", paddingBottom: "20px" }}>
    <div className="col-header" style={{ marginBottom: "20px", width: "100%" }}>
        <div className="title">
            <img src="https://i.ibb.co/1GbMqn4L/image.png" alt="icon" className="title-icon" /> 
            Khuyến mãi
        </div>
    </div>
    
    <Swiper {...swiperBanner} style={{ paddingBottom: "20px" }}>
        {notify && notify.map((item, index) => {
            // Khai báo biến title an toàn, chuyển về chữ thường để dễ so sánh
            const itemTitle = item.title ? item.title.toLowerCase() : "";

            // Lọc ra các item:
            // 1. Được phép hiển thị (isShow === true)
            // 2. Không phải là popup hay marquee
            // 3. Tiêu đề KHÔNG CHỨA chữ "banner" (để loại bỏ "BANNER TRANG CHỦ")
            if (
                item.isShow === true && 
                !itemTitle.includes("marquee") && 
                !itemTitle.includes("popup") && 
                !itemTitle.includes("banner") 
            ) {
                return (
                    <SwiperSlide key={index} className="promo-slide">
                        <div 
                            className="promo-card-home"
                            onClick={() => {
                                if (item.title && item.title.indexOf("{") !== 0) {
                                    setNotifyItem(item);
                                    setShow(true);
                                } else if (item.content) {
                                    navigate(item.content.replace(/<\/?[^>]+(>|$)/g, ""));
                                }
                            }}
                        >
                            <img 
                                src={item.image} 
                                alt={item.title ? item.title.replace(/[{}]+/g, "") : "Khuyến mãi"} 
                                className="promo-card-img"
                            />
                            <div className="promo-card-footer">
                                <div className="promo-card-title">
                                    {item.title ? item.title.replace(/[{}]+/g, "") : ""}
                                </div>
                                <button className="btn-xem-them">Xem thêm</button>
                            </div>
                        </div>
                    </SwiperSlide>
                )
            }
            return null;
        })}
    </Swiper>
</div>

                    {/* ================= TÍNH NĂNG VƯỢT TRỘI (ĐÃ UPDATE ẢNH) ================= */}
                    <div className="features-container">
                        <div className="features-title-wrap" style={{ textAlign: "center", marginBottom: "40px" }}>
                            <img 
                                src="https://i.ibb.co/r23XLFyP/nh-ng-t-nh-n-ng-v-t-tr-i-c-a-bia88-1.png" 
                                alt="Những tính năng vượt trội" 
                                className="f-title-img"
                            />
                        </div>
                        
                        <div className="features-grid">
                            <div className="f-item">
                                <img src="https://i.ibb.co/nsT4LPXn/image.png" alt="Nạp rút" className="f-icon-img" />
                                <div className="f-item-title">NẠP/RÚT SIÊU TỐC</div>
                                <div className="f-item-desc">Đa dạng hình thức, đơn giản thao tác, xử lý nhanh chóng - Mọi giao dịch của quý khách sẽ được xử lý với tốc độ nhanh nhất.</div>
                            </div>
                            
                            <div className="f-item">
                                <img src="https://i.ibb.co/Wvvn230D/image.png" alt="Công bằng" className="f-icon-img" />
                                <div className="f-item-title">CÔNG BẰNG & MINH BẠCH</div>
                                <div className="f-item-desc">Cam kết trả thưởng nhanh chóng, kết quả được công bố minh bạch, rõ ràng, trực tiếp từ Nhà cung cấp và Ban tổ chức.</div>
                            </div>
                            
                            <div className="f-item">
                                <img src="https://i.ibb.co/0y8fsxYg/image.png" alt="Bảo mật" className="f-icon-img" />
                                <div className="f-item-title">AN TOÀN & BẢO MẬT</div>
                                <div className="f-item-desc">Mọi thông tin tại QH88 được bảo mật tuyệt đối bằng kết nối Blockchain. Cam kết an toàn tuyệt đối cho thông tin người chơi.</div>
                            </div>
                            
                            <div className="f-item">
                                <img src="https://i.ibb.co/S4SJf3d3/image.png" alt="Hỗ trợ" className="f-icon-img" />
                                <div className="f-item-title">HỖ TRỢ TRỰC TUYẾN 24/7</div>
                                <div className="f-item-desc">Chuyên nghiệp, am hiểu, hỗ trợ xuyên suốt - QH88 giải đáp mọi thắc mắc mà quý khách hàng cần.</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

         

            {/* ================= HIỂN THỊ POPUP CHI TIẾT KHUYẾN MÃI ================= */}
            {notifyItem != null && isShow ? (
                <div className="custom-popup-backdrop" onClick={() => setShow(false)}>
                    <div className="custom-popup-main" onClick={(e) => e.stopPropagation()}>
                        <div className="custom-popup-header">
                            {notifyItem.title.replace("}", "").replace("{", "")}
                        </div>
                        <div className="custom-popup-content">
                            {notifyItem.content.indexOf("{") !== -1 && notifyItem.content.indexOf("}") !== -1 ? (
                                <>
                                    <img
                                        src={notifyItem.content.substring(notifyItem.content.indexOf("{") + 1, notifyItem.content.indexOf("}"))}
                                        alt="Promo Detail"
                                    />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: notifyItem.content.replace(
                                                notifyItem.content.substring(notifyItem.content.indexOf("{"), notifyItem.content.indexOf("}") + 1),
                                                ""
                                            )
                                        }}
                                    />
                                </>
                            ) : (
                                <div dangerouslySetInnerHTML={{ __html: notifyItem.content }} />
                            )}
                        </div>
                        <button onClick={() => setShow(false)} className="btn-close-popup">
                            ĐÓNG
                        </button>
                    </div>
                </div>
            ) : null}

            {/* ================= HIỂN THỊ IFRAME GAME ================= */}
            {playGame && (
                <div className="iframe-game-backdrop" style={{ 
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", 
                    backgroundColor: "#000", zIndex: 99999, display: "flex", flexDirection: "column"
                }}>
                    <div style={{
                        width: "100%", height: "50px", backgroundColor: "#162a35", 
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        padding: "0 15px", boxSizing: "border-box"
                    }}>
                        <div style={{ color: "#ffcc00", fontWeight: "bold", fontSize: "18px", fontFamily: "sans-serif" }}>
                            {sanh}
                        </div>
                        <button 
                            onClick={handleCloseGame} 
                            style={{ 
                                display: "flex", alignItems: "center", justifyContent: "center", gap: "4px",
                                backgroundColor: "#ff5050", color: "#fff", border: "none",
                                borderRadius: "20px", padding: "6px 16px", fontSize: "14px", fontWeight: "600", cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        title={`Sảnh ${sanh}`}
                        style={{ width: "100%", flexGrow: 1, border: "none" }} 
                        allowFullScreen
                    ></iframe>
                </div>
            )}
            
            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&family=Be+Vietnam+Pro:wght@400;500;600;700&display=swap');

                .main-layout-bg {
                    font-family: 'Montserrat', 'Be Vietnam Pro', sans-serif;
                    background-color: #0b1120; 
                    min-height: 100vh;
                    color: #000000;
                }
                a { text-decoration: none; }
                .main-banner-wrap { width: 100%; overflow: hidden; background: #000; }
                img {
                    max-width: 100%;
                    max-height: 110%;
                    width: auto;
                    height: auto;
                }
                .full-width-section {
                    width: 100%;
                    background: #1f2133 url(https://i.ibb.co/KpXKK1DL/image.png) no-repeat top/1920px auto; 
                    background-size: cover; background-position: top center;
                    padding: 30px 0;
                }
                .content-wrapper { 
                    width: 100%; max-width: 1440px; margin: 0 auto; padding: 0 40px; 
                }

                /* MARQUEE */
                .marquee-bar { background: rgba(11, 17, 32, 0.9); border-bottom: 1px solid rgba(255,255,255,0.05); padding: 8px 0; }
                .marquee-container { display: flex; align-items: center; max-width: 1440px; margin: 0 auto; padding: 0 40px; }
                .marquee-content { flex: 1; overflow: hidden; color: #94a3b8; font-size: 13px; font-family: 'Be Vietnam Pro', sans-serif; }

                /* NÚT CHUNG */
                .btn-cyan {
                   display: flex;
                    align-items: center;
                    justify-content: center;
                    white-space: nowrap;
                    -webkit-user-select: none;
                    user-select: none;
                    transition: .2s;
                    font-size: 12px;
                    color: #ecfaff;
                    background-image: linear-gradient(0deg, #192c64 2.08%, #05c3ff 98.61%);
                    border: 2px solid #05c3ff;
                    border-radius: 80px;
                    width: 106px;
                    height: 34px;
                    margin-top: 10px;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 30px;
                    text-align: center;
                    letter-spacing: .7px;
                    cursor: pointer;
                }
                .swiper-button-next, .swiper-button-prev {
                    position: absolute;
                    top: var(--swiper-navigation-top-offset, 39%);
                    width: calc(var(--swiper-navigation-size) / 44 * 27);
                    height: var(--swiper-navigation-size);
                    margin-top: calc(0px - (var(--swiper-navigation-size) / 2));
                    z-index: 10;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--swiper-navigation-color, var(--swiper-theme-color));
                }
                .btn-cyan:hover { transform: scale(1.05); filter: brightness(1.1); }
                .btn-sm { padding: 5px 18px; font-size: 11px; }

                /* ================= WC SWIPER ================= */
                .wc-section { padding: 10px 0 40px 0; }
                .wc-swiper { padding-bottom: 50px !important; } 
                .wc-section .swiper-pagination { bottom: 15px !important; } 
                .wc-swiper .swiper-wrapper { align-items: flex-start; display: flex; } 
                
                .wc-card {
                    background: linear-gradient(180deg,#2e3b74 0,#212a42);
                    border-radius: 12px; 
                    padding: 20px 15px 35px 15px;
                    text-align: center;
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    position: relative;
                    margin-bottom: 20px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.4);
                }
                .wc-header { font-size: 14px; font-weight: 800; color: #fff; margin-bottom: 5px; }
                .wc-time { font-size: 11px; color: #94a3b8; font-weight: 500; margin-bottom: 25px; }
                
                .wc-teams { display: flex; justify-content: space-between; align-items: center; padding: 0 10px; }
                .wc-teams .team { width: 40%; display: flex; flex-direction: column; align-items: center; }
                .wc-teams .team img { width: 45px; height: 30px; object-fit: contain; margin-bottom: 10px; }
                .wc-teams .team span { font-size: 11px; font-weight: 700; text-transform: uppercase; color: #e2e8f0; line-height: 1.2; height: 26px; }
                .wc-teams .vs { font-size: 15px; font-weight: 800; color: #475569; padding-bottom: 20px; }
                
                .wc-btn-wrap {
                    position: absolute;
                    bottom: -15px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: max-content;
                    z-index: 10;
                }
                .btn-wc { 
                    padding: 8px 30px; 
                    font-size: 13px; 
                   color: #ecfaff;
                    background-image: linear-gradient(0deg, #192c64 2.08%, #05c3ff 98.61%);
                    border: 2px solid #05c3ff;
                }
                
                .swiper-button-next, .swiper-button-prev { 
                    width: 35px; height: 35px; 
                    background: linear-gradient(180deg, #1c2a4f 0%, #0d172e 100%); 
                    border-radius: 50%; 
                    color: #00d2ff !important; 
                    border: 1px solid rgba(0, 210, 255, 0.3); 
                    box-shadow: 0 4px 10px rgba(0,0,0,0.5);
                }
                .swiper-button-next:after, .swiper-button-prev:after { font-size: 14px !important; font-weight: 800; }
                .swiper-pagination-bullet { background: #475569; opacity: 1; }
                .swiper-pagination-bullet-active { background: #00d2ff; width: 20px; border-radius: 4px; }

                /* ================= HOT NHẤT TITLE ================= */
                .section-title-wrap {
                    display: flex; justify-content: center; align-items: center; margin: -45px 0 40px 0; gap: 20px;
                }
                .section-title { font-size: 26px; color: #00d2ff; font-weight: 800; margin: 0; }
                .tech-line { height: 1px; width: 120px; background: #3b5998; position: relative; }
                .tech-line.left:after { content: ''; position: absolute; right: -8px; top: -4px; width: 8px; height: 8px; border-top: 1px solid #3b5998; border-right: 1px solid #3b5998; transform: rotate(45deg); }
                .tech-line.right:before { content: ''; position: absolute; left: -8px; top: -4px; width: 8px; height: 8px; border-bottom: 1px solid #3b5998; border-left: 1px solid #3b5998; transform: rotate(45deg); }

                /* ================= BỐ CỤC GRID ================= */
                .hot-grid { display: grid; grid-template-columns: 1fr; gap: 30px; }
                @media (min-width: 1024px) {
                    .hot-grid { grid-template-columns: 63% 35%; justify-content: space-between; }
                }

                /* ================= CHỈNH LẠI HEADER TỪNG CỘT & ICON ================= */
                .col-header { 
                    display: flex; 
                    justify-content: space-between; 
                    align-items: center; 
                    margin-bottom: 25px; 
                    width: 100%; 
                }
                .col-header .title { 
                    font-size: 30px;
                    font-weight: 800; 
                    color: #00d2ff;
                    display: flex; 
                    align-items: center; 
                    gap: 0px; 
                }
                
                .title-icon {
                    width: 70px;
                    height: 100px;
                    object-fit: contain;
                }
                
                /* ================= THỂ THAO & ẢNH NỀN ================= */
                .sports-card-main {
                    background-color: #162446;
                    background-image: url('https://i.ibb.co/Kz2N5f2q/image.png');
                    background-size: cover; 
                    background-position: center;
                    border-radius: 16px; border: 1px solid rgba(255,255,255,0.05);
                    position: relative; min-height: 380px; display: flex; align-items: center; 
                }
                .sports-card-main::before {
                    content: ''; position: absolute; inset: 0;
                    background: linear-gradient(90deg, rgba(11,17,32,0.95) 0%, rgba(11,17,32,0.4) 100%);
                    z-index: 1; border-radius: 16px; 
                }
                .sports-character {
                    position: absolute; left: -100px; bottom: 0; 
                    height: 125%; 
                    z-index: 2; object-fit: contain; pointer-events: none;
                }
                .sports-info { position: relative; z-index: 3; margin-left: 27%; padding: 30px 20px; }
                .sports-info h2 { font-size: 42px; font-weight: 900; margin: 0 0 15px 0; line-height: 1.1; }
                .sports-info p { font-size: 13px; font-weight: 500; font-family: 'Be Vietnam Pro', sans-serif; color: #cbd5e1; line-height: 1.6; margin-bottom: 25px; }
                
                /* LƯỚI LOGO TRONG KHUNG KHIÊN XANH */
                .provider-grid { display: flex; flex-wrap: wrap; gap: 10px; }
                .p-item { text-align: center; width: 85px; cursor: pointer; transition: 0.3s; display: flex; flex-direction: column; align-items: center;}
                .p-item span { font-size: 11px; color: #cbd5e1; font-weight: 900; display: block; margin-top: 5px; line-height: 1.2;}
                .p-icon { width: 85px; height: 85px; background-size: 100% 100%; background-repeat: no-repeat; background-position: center; margin: 0px auto 0px auto; display: flex; align-items: center; justify-content: center; background-color: transparent; padding-bottom: 10px;}
                .p-icon img { width: 38px; max-height: 50px; object-fit: contain;}

                /* ================= CASINO & ẢNH NỀN ================= */
                .casino-list { display: flex; flex-direction: column; gap: 15px; }
                .promo-slide { cursor: pointer; transition: transform 0.3s ease; }
                .promo-slide:hover { transform: translateY(-5px); }

                /* ================= KHUYẾN MÃI CARD ================= */
                .promo-card-home {
                    background-color: #1e293b;
                    border-radius: 12px;
                    overflow: hidden;
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
                }
                .promo-card-home:hover {
                    box-shadow: 0 4px 20px rgba(0, 210, 255, 0.2);
                    border-color: rgba(0, 210, 255, 0.4);
                }
                .promo-card-img {
                    width: 100%;
                    height: 135px;
                    object-fit: cover;
                    display: block;
                }
                .promo-card-footer {
                    padding: 12px 15px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: #1c2642;
                    border-top: 1px solid rgba(255, 255, 255, 0.05);
                }
                .promo-card-title {
                    font-size: 13px;
                    color: #cbd5e1;
                    font-weight: 700;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 60%;
                    text-transform: uppercase;
                }
                .btn-xem-them {
                    background: linear-gradient(90deg, #00d2ff 0%, #3a7bd5 100%);
                    color: #fff;
                    border: none;
                    padding: 6px 16px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 700;
                    cursor: pointer;
                    white-space: nowrap;
                    transition: all 0.3s ease;
                }
                .btn-xem-them:hover {
                    filter: brightness(1.2);
                }

                /* ================= CSS POPUP ================= */
                .custom-popup-backdrop {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0, 0, 0, 0.7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 99999;
                    backdrop-filter: blur(4px);
                }
                .custom-popup-main {
                    background: #1e293b;
                    width: 90%;
                    max-width: 600px;
                    max-height: 85vh;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.5);
                    display: flex;
                    flex-direction: column;
                    border: 1px solid rgba(255,255,255,0.1);
                }
                .custom-popup-header {
                    background: linear-gradient(90deg, #192c64, #05c3ff);
                    color: #fff;
                    padding: 15px 20px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    text-transform: uppercase;
                }
                .custom-popup-content {
                    padding: 20px;
                    overflow-y: auto;
                    flex: 1;
                    font-size: 14px;
                    line-height: 1.6;
                    color: #cbd5e1;
                }
                .custom-popup-content img {
                    max-width: 100%;
                    height: auto;
                    border-radius: 8px;
                    margin-bottom: 15px;
                }
                .btn-close-popup {
                    background: #ff5050;
                    color: white;
                    border: none;
                    width: 100%;
                    padding: 14px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    text-transform: uppercase;
                    transition: 0.3s;
                }
                .btn-close-popup:hover {
                    background: #cc0000;
                }

                /* ================= TÍNH NĂNG MỚI (UPDATE ẢNH) ================= */
                .features-container {
                    margin-top: 60px;
                    padding-bottom: 50px;
                    text-align: center;
                }
                
                .f-title-img {
                    width: 170%;
                    max-width: 1460px;
                    display: block;
                    margin: 0 auto;
                }

                .features-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 30px;
                    align-items: start;
                    padding-top: 20px;
                    position: relative;
                }
                .f-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    position: relative;
                }
                .f-item:not(:last-child)::after {
                    content: '';
                    position: absolute;
                    right: -15px;
                    top: 0;
                    height: 100%;
                    width: 1px;
                    background: rgba(255, 204, 0, 0.3);
                }
                
                /* Tùy chỉnh cho icon là ảnh */
                .f-icon-img {
                    width: 65px;
                    height: 65px;
                    object-fit: contain;
                    margin-bottom: 20px;
                }

                .f-item-title {
                    color: #ffcc00;
                    font-size: 16px;
                    font-weight: 800;
                    margin-bottom: 15px;
                }
                .f-item-desc {
                    color: #cbd5e1;
                    font-size: 13px;
                    line-height: 1.6;
                }

                /* ================= SIDEBAR RIGHT MENU ================= */
                .right-sidebar-contact {
                    position: fixed;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #0b1120;
                    border: 1px solid rgba(255,255,255,0.1);
                    border-right: none;
                    border-radius: 8px 0 0 8px;
                    z-index: 9999;
                    display: flex;
                    flex-direction: column;
                }
                .sidebar-item {
                    padding: 15px 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    border-bottom: 1px solid rgba(255,255,255,0.1);
                    cursor: pointer;
                    transition: 0.3s;
                    text-decoration: none;
                    color: #fff;
                }
                .sidebar-item:last-child {
                    border-bottom: none;
                }
                .sidebar-item:hover {
                    background: rgba(255,255,255,0.05);
                    color: #00d2ff;
                }
                .sb-icon {
                    font-size: 24px !important;
                    margin-bottom: 5px;
                }
                .sidebar-item span {
                    font-size: 10px;
                    font-weight: 600;
                }

                /* ================= RESPONSIVE ================= */
                @media (max-width: 1024px) {
                    .features-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 40px 20px;
                    }
                    .f-item:nth-child(2)::after {
                        display: none;
                    }
                }

                @media (max-width: 768px) {
                    .content-wrapper { padding: 0 15px; }
                    .sports-character { height: 95%; opacity: 0.5; left: -30px; } 
                    .sports-info { margin-left: 10px; }
                    .sports-info h2 { font-size: 32px; }
                    .col-header .title { font-size: 20px; }
                    .title-icon { width: 35px; height: 35px; }
                    .promo-card-title { font-size: 12px; }
                    .btn-xem-them { padding: 5px 12px; font-size: 11px; }
                    
                    .app-block { width: 100%; }
                    .qr-row { justify-content: center; }
                    .web-block { flex-direction: column; text-align: center; }
                    .app-title { font-size: 26px; text-align: center; margin-top: 20px;}
                }

                @media (max-width: 640px) {
                    .features-grid {
                        grid-template-columns: 1fr;
                    }
                    .f-item::after { display: none !important; }
                    .right-sidebar-contact { display: none; }
                }
            `}} />
        </div>
    );
}

export default Home;